// Copy the QR *image* (PNG) to the clipboard from the Promote Event card. Reuses the
// same PNG endpoint as Download PNG (no duplicate QR generation): fetch the blob and
// write it via the async Clipboard API (ClipboardItem). Where image-clipboard isn't
// supported, fall back to copying the public URL, and show a message that makes clear
// which of the two was copied.
const QrImageCopy = {
  start() {
    $('[data-qr-copy]').on('click', function (e) {
      e.preventDefault();
      const $btn = $(this);
      const original = $btn.attr('data-tooltip') || '';
      const confirm = (message) => {
        $btn.attr('data-tooltip', message);
        setTimeout(() => $btn.attr('data-tooltip', original), 3000);
      };
      const copyUrl = () =>
        QrImageCopy.writeText($btn.data('qrUrl')).then(() => confirm($btn.data('copiedUrl')));

      if (QrImageCopy.canCopyImages()) {
        fetch($btn.data('qrCopy'))
          .then((response) => response.blob())
          .then((blob) => navigator.clipboard.write([new ClipboardItem({ [blob.type]: blob })]))
          .then(() => confirm($btn.data('copiedImage')))
          .catch(copyUrl); // permission denied / unsupported type -> copy the URL instead
      } else {
        copyUrl();
      }
    });
  },

  canCopyImages() {
    return (
      typeof ClipboardItem !== 'undefined' &&
      !!navigator.clipboard &&
      typeof navigator.clipboard.write === 'function'
    );
  },

  writeText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    // Legacy fallback: a temporary textarea + execCommand.
    return new Promise((resolve) => {
      const el = document.createElement('textarea');
      el.value = text;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      try { document.execCommand('copy'); } catch (err) { /* no-op */ }
      document.body.removeChild(el);
      resolve();
    });
  },
};

export default QrImageCopy;
